export default __webpack_public_path__ + "static/media/sun.66b2bb77.svg";